import React from "react";

// interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
//   children: React.ReactNode;
//   variant?: "default" | "success" | "warning" | "error" | "info";
// }

export function Badge({ children, variant = "default", className = "", ...props }) {
  const variantClasses = {
    default: "bg-gray-100 text-gray-800",
    success: "bg-green-100 text-green-800",
    warning: "bg-yellow-100 text-yellow-800",
    error: "bg-red-100 text-red-800",
    info: "bg-blue-100 text-blue-800",
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
